export const environment = {
  production: false,
  baseUrl: 'https://api-mmjjb-staging.gms.church',
  clientId: '724902f2109c1f01a93819c2017866ea',
  clientSecret: 'wjv7gdhvv680m47ys8f3t9xtphyi9j1d',
  tokenHost: 'https://accounts.gms.church',
  callbackUrl: 'https://mmjjb-staging.gms.church/auth/callback',
};
